import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-grade-scale-class-map',
  templateUrl: './grade-scale-class-map.component.html',
  styleUrls: ['./grade-scale-class-map.component.css']
})
export class GradeScaleClassMapComponent implements OnInit {
  dropdownSettings: any = {};
  selectedItems: any = [];
  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
  
  GradeScaleModel = {
    GradeScaleClassMapID:0,
    GradeScaleID: 0,
    ClassIDs: '',
    IsActive:true,
    ClassList:[]
};
ClassList:any;
Submitted = false;
Clear  () {
    this.GradeScaleModel.GradeScaleClassMapID = 0;
    this.GradeScaleModel.GradeScaleID = 0;
    this.GradeScaleModel.IsActive = true;
    this.Submitted = false;
    this.GradeScaleModel.ClassList=[];
}
 ValidityState() {
    return this.GradeScaleModel.GradeScaleID == 0;
}
 GetCommaClass() {
    var ClassIDs = '';
    var ClassList = this.GradeScaleModel.ClassList;
    for (var i = 0; i < ClassList.length; i++) {
        if ( ClassIDs == '') {
            ClassIDs = ClassList[i].ItemId;
        }
        else  {
            ClassIDs = ClassIDs + "," + ClassList[i].ItemId;
        }
    }
    this.GradeScaleModel.ClassIDs = ClassIDs;
}

SaveGradeScaleClassMap  () {
    this.Submitted = true;
    this.GetCommaClass();
    if (!this.ValidityState()) {
      this.spinnerService.show();
        this.examService.SaveGradeScaleClassMap(JSON.stringify(this.GradeScaleModel)).subscribe( (response) =>{
          this.spinnerService.hide();
                this.Submitted = false;
           
            this.globalHelper.CheckActionStatus(response);
            if (response.webResponse.Status) {
                this.GetGradeScaleClassMap();
                this.Clear();
            }

        })
    }
};



GradeScaleClassMapList:any;
GetGradeScaleClassMap  () {
    this.spinnerService.show();
    this.examService.GetGradeScaleClassMap().subscribe( (response)=> {
        this.GradeScaleClassMapList = response.GradeScaleClassMapList;
        this.spinnerService.hide();
    });
};


Edit  (obj) {
   this.selectedItems = [];
    this.GradeScaleModel.GradeScaleClassMapID = obj.GradeScaleClassMapID;
    this.GradeScaleModel.GradeScaleID = obj.GradeScaleID;
    this.GradeScaleModel.IsActive = obj.IsActive;
    var ClassName = obj.ClassName.split(',');
    for (var i = 0; i < this.ClassList.length; i++) {
      
        for (var j = 0; j < ClassName.length; j++) {
            if (ClassName[j] == this.ClassList[i].ItemName) {
              let item = {
                ItemId: this.ClassList[i].ItemId,
                ItemName: this.ClassList[i].ItemName
              }
              this.selectedItems.push(item)
                break;
            }
        }
    }
    this.GradeScaleModel.ClassList=this.selectedItems;
    
   

   
}


GetStatus  (IsActive) {
    return IsActive ? 'Yes' : 'No';
};



GetAllClass  () {
    this.lookupService.GetLookupsList('Class', '').subscribe( (data)=> {
        this.ClassList = data.LookupItems;
        this.ClassList.splice(0, 1);
    });
};
GradeScaleList:any;
GetAllGradeScale  () {
    this.lookupService.GetLookupsList('GradeScale', '').subscribe( (data)=> {
        this.GradeScaleList = data.LookupItems;
    });

};
  ngOnInit() {
    this.GetAllClass();
    this.GetAllGradeScale();
    this.GetGradeScaleClassMap();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };
  }

}
